/**
 * Converte uma string ou número em formato brasileiro para um número.
 * @param value - A string ou número a ser convertido.
 * @returns O número convertido.
 */
export function parseBrazilianCurrency(value: string | number | null): number {
  if (value === null || value === undefined || value === '') {
    return NaN;
  }

  if (typeof value === 'number') {
    return value;
  }

  const normalized = value
    .replace(/R\$\s?/g, '')
    .replace(/\./g, '')
    .replace(',', '.')
    .trim();

  return Number(normalized);
}

/**
 * Converte um número em formato brasileiro para uma string.
 * @param value - O número a ser convertido.
 * @returns A string formatada em reais (R$ 1.000,00).
 */
export function formatBrazilianCurrency(value: number | string): string {
  const amount = typeof value === 'number' ? value : parseBrazilianCurrency(value);

  if (isNaN(amount)) {
    return '';
  }

  const [integerPart, decimalPart = '00'] = amount.toFixed(2).split('.');
  const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.');

  return `R$ ${formattedInteger},${decimalPart}`;
}
